import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { useWizardSummaryContext } from "../wizard/wizardSummaryContext";
import './togglebox.css';

type Props = {
    name: string,
    label: string
    onChanged?: () => void,
    disabled?: boolean,
    cyName?: string
}

const Togglebox: FC<Props> = ({ name, label, onChanged, disabled, cyName }) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const { updateSummary } = useWizardSummaryContext();

    const handleOnClick = () => {
        let currentValue = name.split('.').reduce((previous, current) => previous?.[current], values as any);

        if (typeof currentValue != "boolean") {
            currentValue = (currentValue == '0' ? false : true);
        }

        if (onChanged) {
            onChanged()
        }
        else {
            setFieldValue(name, !currentValue);
        }
        updateSummary(name, !currentValue === true ? 'Yes' : 'No');
    }

    const convertFieldToBoolean = (field: any) => {
        let fieldValue = field.value;

        if (typeof fieldValue != "boolean") {
            fieldValue = (fieldValue == '0' ? false : true);
        }
        return fieldValue;
    }

    return <Field name={name}>
        {({ field }) => (<>
            <div className={"form-switch inline-block align-middle"} data-cy={`${cyName}ToggleBox`} onClick={!disabled ? (e) => handleOnClick() : undefined}>
                <input className="form-switch-checkbox"
                    type="checkbox"
                    checked={convertFieldToBoolean(field)} />
                <label className={!disabled ? "form-switch-label cursor-pointer" : "form-switch-label cursor-not-allowed" }/>
            </div>
            {label && <label className="text-xs text-gray-600">{label}</label>}
        </>)}
    </Field>
};

export default Togglebox;
